import React from 'react';

import { FormattedMessage } from 'react-intl';

import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';

import { useReshipContext } from '../../../../reship/reship-context-provider';
import { messages } from '../../../../reship/messages';

export const ReshipShipmentMenuItem = () => {
  const { reship, canReship } = useReshipContext();

  return (
    <DropdownMenuItem disabled={!canReship} onClick={reship}>
      <FormattedMessage {...messages.reshipButton} />
    </DropdownMenuItem>
  );
};
